<template>
    <LeftSidebar v-if="!appData.isMobile">
        <li class="nav-link" v-for="r in pc" :key="r">
            <router-link :to="Links.Url(r.link, r.args)" :title="r.text" :class="[ isSelectUrl(Links.Url(r.link, r.args)) ? 'active' : '' ]">
                <span class="menu-icon" aria-hidden="true">
                    <svg v-if="r.icon === 'icon-dashboard'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect width="7" height="7" x="3" y="3" rx="1"/><rect width="7" height="7" x="14" y="3" rx="1"/><rect width="7" height="7" x="14" y="14" rx="1"/><rect width="7" height="7" x="3" y="14" rx="1"/></svg>
                    <svg v-else-if="r.icon === 'icon-user'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/></svg>
                    <svg v-else-if="r.icon === 'icon-books-list'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3 10 5-10 5L2 8l10-5ZM2 12l10 5 10-5M2 16l10 5 10-5"/></svg>
                    <svg v-else-if="r.icon === 'icon-bookmark'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>
                    <svg v-else-if="r.icon === 'icon-folderbag'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5l2 2h9a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2Z"/></svg>
                    <svg v-else-if="r.icon === 'icon-chevron-left'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>
                    <svg v-else-if="r.icon === 'icon-book-open-reader'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 7v14M3 3h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5v15h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3H3Z"/></svg>
                </span>
                <span class="link-name">{{r.text}}</span>
            </router-link>
        </li>
        <!--<li class="nav-link" v-if="type == Enums.MENU_TYPE.MAIN">
            <a href="javascript:void(0)" @click="logout" title="Çıkış">
                <i class="icon icon-left-from-bracket"></i>
                <span class="link-name">Çıkış</span>
            </a>
        </li>-->
    </LeftSidebar>
    <LeftSidebarMobile :items="mobile" :isActive="isSelectUrl" v-else class="consultant-fixed-footer" />
</template>
<script>
    import { Enums } from "@/helpers/enums";
    import { Links } from "@/helpers/links";
    import { appData, C } from "@/helpers/global";

    import LeftSidebar from "@/layouts/_partials/LeftSidebar.vue";
    import LeftSidebarMobile from "@/layouts/_partials/LeftSidebar.mobile.vue";

    export default {
        props: ["type"],
        components: {
            LeftSidebar,
            LeftSidebarMobile,
        },
        methods: {
            isSelectUrl(link) {
                if(C.Str(this.$route.path) == link)  { return true; } 
                return (C.Str(this.$route.path).indexOf(link.replace(/\/0/g, '')) == 0); 
            }
        },
        computed: {
            pc() {
                switch (this.type) {
                    case Enums.MENU_TYPE.DOCUMENT:
                        return [
                            { icon: "icon-dashboard", link: Links.Dashboard, text: "Panelim" },
                            //{ icon: "icon-bookmark", link: Links.Document.PrivateList, args: [0], text: "Özel" },
                            { icon: "icon-folderbag", link: Links.Document.PublicList, text: "Genel" },
                        ];
                    case Enums.MENU_TYPE.MAIN:
                    default:
                        return [
                            { icon: "icon-dashboard", link: Links.Dashboard, text: "Panelim" },
                            //{ icon: "icon-book-open-reader", link: Links.Education.List, text: "Eğitimlerim" },
                            { icon: "icon-books-list", link: Links.Document.PublicList, text: "Dokümanlarım" },
                            { icon: "icon-user", link: Links.User.Profile, text: "Hesabım" },
                        ];
                }
            },
            mobile() {
                switch (this.type) {
                    case Enums.MENU_TYPE.DOCUMENT:
                        return [
                            { icon: "icon-bookmark", link: Links.Document.PrivateList, args: [0], text: "Özel" },
                            { icon: "icon-folderbag", link: Links.Document.PublicList, text: "Genel" },
                            null,
                            null,
                            { icon: "icon-chevron-left", link: Links.Dashboard, text: "Panelim" },
                        ];
                    case Enums.MENU_TYPE.MAIN:
                    default:
                        return [
                            { icon: "icon-book-open-reader", link: Links.Education.List, text: "Eğitimlerim" },
                            { icon: "icon-books-list", link: Links.Document.PublicList, text: "Dokümanlarım" },
                            { icon: "icon-user", link: Links.User.Profile, text: "Hesabım" },
                            null,
                            { icon: "icon-dashboard", link: Links.Dashboard, text: "Panelim", isMain: true },
                        ];
                }
            }
        }
    };
</script>